import { FallbackProps } from 'react-error-boundary';
import styled from 'styled-components';

import { Button } from 'app/theme/Button';
import { Icon } from 'app/theme/Icons/Icon';
import { breakpoint } from 'app/theme/theme';
import { fileUploader } from 'app/translations/dictionary';
import { FileUploadError } from 'pkg/components/FileUploader/fileUploaderService';

const FallbackContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 3rem 2rem;
`;

const ErrorIcon = styled(Icon)`
  &&&& {
    display: block;
    margin: 0 auto 2rem auto;
    flex-grow: 1;
    font-size: 8rem;
    color: ${({ theme }) => theme.palette.primary};
  }
`;

const Header = styled.div`
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0;
  padding: 0;

  ${breakpoint.up.md`
    font-size: 2.5rem;
  `}
`;

const Content = styled.p`
  align-self: center;
  flex-grow: 1;
  margin: 2rem 0;
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  text-align: center;
  word-break: break-all;
`;

const TryAgainButton = styled(Button)`
  &&&& {
    font-size: 2rem;
  }
`;

export const FileUploaderErrorFallback = ({ error, resetErrorBoundary }: FallbackProps): JSX.Element => {
  if (error instanceof FileUploadError) {
    return (
      <FallbackContainer>
        <div>
          <ErrorIcon name="exclamation triangle" />
          <Header>{fileUploader.errorFallback.title}</Header>
        </div>
        <Content>{error.message}</Content>
        <TryAgainButton primary onClick={resetErrorBoundary}>
          {fileUploader.errorFallback.tryAgain}
        </TryAgainButton>
      </FallbackContainer>
    );
  }

  throw error;
};
